import React, { FC } from 'react'

import {
  hasPerformanceSupport,
  PerformanceProps,
} from 'components/system/statistic/Perfomance'
import { MeasurerEnd } from 'components/system/statistic/PerfomanceMeasurerEnd'

/**
 * Компонент монтирующийся после загрузки.
 * @param operation
 * @constructor
 */
export const PerformanceEnd: FC<PerformanceProps> = ({ operation }) => {
  if (process.env.browser) {
    if (hasPerformanceSupport()) {
      // console.log('end', operation)
      return <MeasurerEnd operation={operation} />
    }
  }
  return null
}
